"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var currency_js_1 = __importDefault(require("currency.js"));
var jotai_1 = require("jotai");
var react_1 = __importDefault(require("react"));
var selected_variant_state_1 = require("../../misc/selected-variant-state");
var state_1 = require("./state");
var QuickAddAnchor = function (_a) {
    var product = _a.product, productUrl = _a.productUrl, mainImageCover = _a.mainImageCover, buttonText = _a.buttonText, className = _a.className, bottomImageUrl = _a.bottomImageUrl, onClick = _a.onClick;
    var setModalOpen = (0, jotai_1.useSetAtom)(state_1.modalOpenAtom);
    var setProduct = (0, jotai_1.useSetAtom)(state_1.productAtom);
    var setProductUrl = (0, jotai_1.useSetAtom)(state_1.productUrlAtom);
    var setMainImageCover = (0, jotai_1.useSetAtom)(state_1.mainImageCoverAtom);
    var setBottomImageUrl = (0, jotai_1.useSetAtom)(state_1.bottomImageUrlAtom);
    var changeSelectedVariant = (0, selected_variant_state_1.useSelectedVariantStore)(function (state) { return state.change; });
    var handleClick = function (e) {
        // this is a terrible place for this, but because our whole product cards are clickable,
        // we have to stop propagation to prevent them from being clicked when a button within them is clicked
        e.stopPropagation();
        e.preventDefault();
        e.nativeEvent.stopImmediatePropagation();
        // we arbitrarily select the first variant of the product
        var variant = product.variants[0];
        setProduct(product);
        setProductUrl(productUrl);
        setMainImageCover(mainImageCover);
        setBottomImageUrl(bottomImageUrl);
        var newSelectedVariant = __assign(__assign({}, variant), { product: { tags: product.tags, title: product.title } });
        var priceDollars = (0, currency_js_1.default)(newSelectedVariant.price, { fromCents: true }).value;
        changeSelectedVariant({ newVariant: __assign(__assign({}, newSelectedVariant), { price: priceDollars }), emitViewItemEventToGa: true });
        setModalOpen(true);
        if (onClick)
            onClick(product, variant);
    };
    // we intentionally avoid adding too much styling of our own here so that we can be controlled by the caller
    return (react_1.default.createElement("a", { onClick: handleClick, className: className }, buttonText));
};
exports.default = QuickAddAnchor;
